import { cn } from "@/styles/cn";

import { Result, type ResultProps } from "./Result";

type ResultEmptyProps = ResultProps & {
  variant?: "textInline" | "default";
  className?: string;
  subTitle?: React.ReactNode;
};

export function ResultEmpty({
  subTitle = "Por favor, revisa el término de búsqueda.",
  variant = "default",
  className,
  ...props
}: ResultEmptyProps) {
  if (variant === "textInline") {
    return (
      <span className={cn("text-sm text-urbe-error", className)}>No se encontraron resultados</span>
    );
  }

  return (
    <Result icon="search" subTitle={subTitle} title="No se encontraron resultados" {...props} />
  );
}
